import React from "react";
import { Button, Typography, Space, Card } from "antd";
import {
  WarningOutlined,
  ReloadOutlined,
  CopyOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleCopyError = () => {
    const text = `${this.state.error?.name}: ${this.state.error?.message}`;
    navigator.clipboard?.writeText(text);
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 400,
            padding: 48,
          }}
        >
          <Card
            style={{
              maxWidth: 480,
              width: "100%",
              textAlign: "center",
              borderRadius: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
            }}
          >
            <WarningOutlined
              style={{ fontSize: 64, color: "#D97A07", marginBottom: 16 }}
            />
            <Title level={3} style={{ color: "#0D2E4D", marginBottom: 8 }}>
              Something went wrong
            </Title>
            <Text
              type="secondary"
              style={{ display: "block", marginBottom: 24, fontSize: 14 }}
            >
              {this.state.error?.message || "An unexpected error occurred"}
            </Text>
            <Space>
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                style={{ backgroundColor: "#D97A07", borderColor: "#D97A07" }}
                onClick={() => this.setState({ hasError: false, error: null })}
              >
                Try Again
              </Button>
              <Button icon={<CopyOutlined />} onClick={this.handleCopyError}>
                Copy Error
              </Button>
            </Space>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
